import type { EnvironmentId } from '@/deploy/types';
import { ENVIRONMENT_BY_ID } from '@/deploy/types';
import styles from './EnvBadge.module.scss';

interface EnvBadgeProps {
  env: EnvironmentId;
  size?: 'sm' | 'md';
  withDescription?: boolean;
}

export function EnvBadge({ env, size = 'md', withDescription }: EnvBadgeProps) {
  const meta = ENVIRONMENT_BY_ID[env];
  return (
    <span
      className={[styles.envBadge, styles[`size_${size}`]].join(' ')}
      style={{ ['--env-color' as string]: meta.color }}
    >
      <span className={styles.dot} />
      <span className={styles.name}>{meta.name}</span>
      {withDescription && <span className={styles.desc}>· {meta.description}</span>}
    </span>
  );
}
